import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { getSingleWidgetDetail } from "../../../../staticWidgets/utils/CommonWidgetApi";
import { getTemplateDetail, getDummyLogoShowcase } from "../../../../utils/logoShowcaseApi";

const LogoShowcaseTemplateWidget = ({ selectedTemplate, isTemplateId, widgetId, logoShowcaseTabData, refreshWidgetList }) => {
    const [apiData, setApiData] = useState(false);
    const [sliderSettings, setSliderSettings] = useState(null);

    const {
        is_website_frontend,
        is_show_header,
        header_title,
        header_caption,
        is_show_action_button,
        action_link,
        action_text,
        background_color,
        logo_custom_color,
        button_text_color,
        button_color,
        button_font_size,
        position_alignment,
        header_title_color,
        header_caption_color,
        header_title_font_size,
        header_caption_font_size,
        logo_size,
        spacing_between_logo,
        sidebar_layout_type
    } = logoShowcaseTabData || {};

    // Call Css
    useEffect(() => {
        // Remove other module CSS
        const oldLinks = document.querySelectorAll('link[data-dynamic-css]');
        oldLinks.forEach(link => link.remove());

        // Load CSS
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `${process.env.PUBLIC_URL}/logo-showcase/temp-css/LogoShowcase.css`;
        if (widgetId) {
            link.setAttribute("logo-showcase-data-dynamic-css", "logo-showcase");
        } else {
            link.setAttribute("data-dynamic-css", "logo-showcase");
        }
        document.head.appendChild(link);

        // Clean up on unmount
        return () => {
            const thisLink = document.querySelector('link[data-dynamic-css="logo-showcase"]');
            if (thisLink) thisLink.remove();
        };
    }, [widgetId]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (isTemplateId) {
                    const result = await getTemplateDetail(isTemplateId);
                    setApiData(result);
                } else if (widgetId) {
                    const result = await getSingleWidgetDetail(widgetId);
                    setApiData(result);
                } else {
                    const result = await getDummyLogoShowcase();
                    setApiData(result);
                }
            } catch (error) {
                // console.error("Error fetching data:", error);
            }
        };

        if (isTemplateId !== undefined || widgetId !== undefined) {
            fetchData();
        }
    }, [isTemplateId, widgetId, refreshWidgetList]);

    useEffect(() => {
        if (apiData?.data?.data_list?.length > 0 && sidebar_layout_type !== 'Grid') {
            const itemCount = apiData.data.data_list.length;

            const commonSettings = {
                dots: false,
                infinite: itemCount > 1,
                slidesToShow: Math.min(itemCount, 8),
                slidesToScroll: 1,
                autoplay: itemCount > 1,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: Math.min(itemCount, 4),
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: Math.min(itemCount, 2),
                        },
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            };

            if (sidebar_layout_type === 'Ticker') {
                setSliderSettings({
                    ...commonSettings,
                    speed: 4000,
                    autoplaySpeed: 0,
                    cssEase: "linear",
                    arrows: false,
                });
            } else if (sidebar_layout_type === 'Carousel') {
                setSliderSettings({
                    ...commonSettings,
                    speed: 500,
                    autoplaySpeed: 3000,
                    arrows: true,
                });
            } else {
                setSliderSettings({
                    ...commonSettings,
                    arrows: false,
                });
            }
        }
    }, [apiData, sidebar_layout_type]);

    const hexToHueRotate = (hex) => {
        switch (hex?.toLowerCase()) {
            case '#ff0000': return 0;
            case '#00ff00': return 90;
            case '#0000ff': return 200;
            case '#ff00ff': return 300;
            case '#ffff00': return 60;
            case '#00ffff': return 150;
            default: return 0;
        }
    };

    const renderLogo = (item, index) => (
        <div className="logo-item" key={index} style={{ padding: spacing_between_logo || '00px', position: 'relative' }}>
            <a
                href={item.logo_link?.trim() || '#'}
                target="_blank"
                rel="noopener noreferrer"
                title={item.logo_caption}
                style={{ display: 'inline-block', position: 'relative' }}
            >
                <img
                    src={item.logo}
                    alt={item.logo_name || `logo-${index}`}
                    style={{
                        height: logo_size || '60px',
                        width: 'auto',
                        maxWidth: '100%',
                        objectFit: 'contain',
                        display: 'block',
                        filter: item.logo?.toLowerCase().endsWith('.svg')
                            ? `brightness(0) saturate(100%) sepia(1) hue-rotate(${hexToHueRotate(logo_custom_color)}deg)`
                            : 'grayscale(1)',
                    }}
                />
                {!item.logo?.toLowerCase().endsWith('.svg') && (
                    <div
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: logo_custom_color || '#000',
                            mixBlendMode: 'multiply',
                            pointerEvents: 'none',
                            borderRadius: '4px',
                        }}
                    />
                )}
            </a>
        </div>
    );

    return (
        <div className={`upgadeify logo_showcase infinite-carousel-temp ${is_website_frontend}`}>
            {apiData?.data?.data_list ? (
                <div className='logo-showcase-temp-inner' style={{ backgroundColor: background_color }}>
                    {Number(is_show_header) === 1 && (
                        <>
                            {header_title && (
                                <h2 className='header-title' style={{ color: header_title_color, textAlign: position_alignment, fontSize: header_title_font_size }}>{header_title}</h2>
                            )}
                            {header_caption && (
                                <p className='header-caption' style={{ color: header_caption_color, textAlign: position_alignment, fontSize: header_caption_font_size }}>{header_caption}</p>
                            )}
                        </>
                    )}

                    <div className='logo-showcase-logo-inner'>
                        {sidebar_layout_type === 'Grid' ? (
                            <div className={`logo-grid-wrapper ${selectedTemplate === 'Partners_Temp' ? 'upgadeify_gridwrapper_color' : ''}`} style={{ display: 'flex', flexWrap: 'wrap', gap: spacing_between_logo || '0px' }}>
                                {apiData.data.data_list.map((item, index) => (
                                    <div key={index} style={{ flex: '1 0 20%' }}>
                                        {renderLogo(item, index)}
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <Slider {...sliderSettings} className={`logo-slider ${sidebar_layout_type === 'Ticker' ? 'ticker-mode' : ''}`}>
                                {apiData.data.data_list.map((item, index) => (
                                    <div className="slick-slide-custom" key={index}>
                                        {renderLogo(item, index)}
                                    </div>
                                ))}
                            </Slider>
                        )}
                    </div>

                    {Number(is_show_action_button) === 1 && action_text && (
                        <div className="contact-us-button">
                            <a
                                href={action_link?.trim() || '#'}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: button_text_color, backgroundColor: button_color, fontSize: button_font_size }}
                            >
                                {action_text}
                            </a>
                        </div>
                    )}
                </div>
            ) : (
                <div className="loader-container">
                    <div className="spinner"></div>
                    <p>Loading please wait...</p>
                </div>
            )}
        </div>
    );
};

export default LogoShowcaseTemplateWidget;
